import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import './style/FeatureCardList.scss'
import FeaturesList from './FeaturesList';
import { Box, Tooltip } from "@mui/material";

const FeatureCardList = ({ isActivePlan }) => {
  const { t } = useTranslation();
  const { mode } = useContext(AppContext);
  const { features } = FeaturesList();

  return (
    <div className='feature-list-card-main'
      style={{
        background: mode === "dark" ? isActivePlan ? "#A49DC8" : "#333333" :
          isActivePlan ? "rgba(164, 157, 200, 0.15)" : "#FFFFFF",
      }}>

      <div>
        {features.map((feature, index) => (
          <FeatureItem key={index} index={index} name={feature.name} />
        ))}
      </div>
    </div>
  )
}

const FeatureItem = ({ name, index }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [name]);

  return (
    <Tooltip title={isOverflowing ? name : ""} disableInteractive>
      <Box ref={textRef} className='feature-list-card-box'
        sx={{
          padding: index == 0 ? 0 : '20px 0 0 0 !important',
          '@media (max-width: 1600px)': {
            padding: index === 0 ? 0 : "15px 0 0 0 !important"
          },
        }}
      >
        {name}
      </Box>
    </Tooltip>
  );
};

export default FeatureCardList
